import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import Axios from 'axios'
import ElementUI from 'element-ui'
import './assets/font.css';
import VueCookies from 'vue-cookies';
import * as echarts from 'echarts';

// import '@/utils/china'
// import './utils/world'
import 'element-ui/lib/theme-chalk/index.css'
import VueClipboard from 'vue-clipboard2'




// import '@/utils/snorql'
Vue.config.productionTip = false
Vue.prototype.$axios = Axios

// Vue.prototype.$baseurl='https://datastore.acemap.info/'
Vue.prototype.$baseurl = window.location.href.indexOf("10.") >= 0 ? 'https://dataexpo.acemap.info/' : 'https://dataexpo.acemap.info/'
Vue.prototype.$echarts = echarts
Vue.use(ElementUI);
Vue.use(VueClipboard)
    // Vue.use(leaflet)
Vue.use(VueCookies)
    // Vue.use(leaflet)
Vue.config.productionTip = false


new Vue({
    router,
    store,
    render: (h) => h(App),
}).$mount("#app");